module.exports = __webpack_public_path__ + "img/smile_icon.1ac9dc00.svg";